// @flow
const START_TIME_WEEKDAYS = '09:00:00';
const END_TIME_WEEKDAYS = '18:00:00';

const START_TIME_SUNDAY = '10:00:00';
const END_TIME_SUNDAY = '16:00:00';

// This is to force return false temporarily. will be reverted back after testing for a week.
export const returnTemporarily = () => {
  const now = Date.now();
  const tillDate = new Date('2020/12/06').getTime();
  if (now < tillDate) {
    return false;
  }

  return true;
};

/**
 * isWorkingHours
 * @return {boolean} returns isWorkingHours
 */
const isWorkingHours = () => {
  if (exports.returnTemporarily()) {
    const now = new Date(Date.now());
    let startTime = START_TIME_WEEKDAYS;
    let endTime = END_TIME_WEEKDAYS;

    // if sunday, use sunday timings
    if (now.getDay() === 0) {
      startTime = START_TIME_SUNDAY;
      endTime = END_TIME_SUNDAY;
    }

    const startDate = new Date(
      now.getMonth() +
        1 +
        '/' +
        now.getDate() +
        '/' +
        now.getFullYear() +
        ' ' +
        startTime
    );
    const endDate = new Date(
      now.getMonth() +
        1 +
        '/' +
        now.getDate() +
        '/' +
        now.getFullYear() +
        ' ' +
        endTime
    );

    const nowTime = now.getTime();
    const startDateTime = startDate.getTime();
    const endDateTime = endDate.getTime();

    // if nowTime is between current days start & end time
    if (nowTime > startDateTime && nowTime < endDateTime) {
      return true;
    }
  }
  return false;
};

export default isWorkingHours;



// WEBPACK FOOTER //
// ./src/utils/isWorkingHours/index.js